import { getRecipientsByCommuncation } from 'modules/communications/api/getRecipientsByCommunication';
import { useCallback, useEffect, useState } from 'react';
import { store } from 'redux/store';
import { CommunicationRecipient } from 'types/Communication';

type UseGetRecipientsDataProps = {
  communicationId?: string;
  page?: number;
  rowsPerPage?: number;
};

export const useGetRecipients = ({
  communicationId,
  page = 1,
  rowsPerPage = 10,
}: UseGetRecipientsDataProps) => {
  const [recipients, setRecipients] = useState<CommunicationRecipient[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  const fetchRecipients = useCallback(
    async (controller: AbortController) => {
      if (!communicationId) return;

      try {
        setIsLoading(true);

        const fetchedRecipients = await store.dispatch(
          getRecipientsByCommuncation({
            communicationId,
            params: {
              page,
              items: rowsPerPage,
            },
            signal: controller.signal,
          })
        );

        if (!controller.signal.aborted) {
          setRecipients(fetchedRecipients);
          setIsLoading(false);
        }
      } catch (error) {
        if (!controller.signal.aborted) {
          setIsLoading(false);
          setIsError(true);
        }
      }
    },
    [communicationId, page, rowsPerPage]
  );

  useEffect(() => {
    const controller = new AbortController();

    fetchRecipients(controller);

    return () => controller.abort();
  }, [fetchRecipients]);

  return { data: { recipients }, isLoading, isError };
};
